module.exports = __webpack_public_path__ + "static/media/Cinnamon Scrolls.1052e728.jpg";